import {displayAuthModal} from './auth-modal'
import 'bootstrap/js/dist/tooltip'

export function apply() {

  $(document).on('click', 'a.apply-link', function(e){
    e.preventDefault();

    fbq('track', 'AddToCart');

    let $this = $(this);
    const isLogged = window.glob_obj.is_logged_in;
    const isInfoFilled = true; // window.glob_obj.is_personal_info_filled

    if (! isLogged) {
      displayAuthModal();
      return false;
    }

    if (isInfoFilled){
      window.location.href = $this.attr('href');
      return true;
    }

    displayPersonalInfoNotFilledModal();
  });
}

export function applyTooltip(){
  $('.toggle-apply-link').hover(function (e){
    const $this = $(this);
    let cl = 'apply-tooltip';

    const tpl = `<div class="tooltip ${cl}" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>`;

    $this.tooltip({
      template: tpl
    });
  })
}

export function displayPersonalInfoNotFilledModal(){
  let modal =
      '<div class="modal fade apply-modal" tabindex="-1" role="dialog" id="apply-modal">' +
      '<div class="modal-dialog" role="document">' +
      '<div class="modal-content">' +
      '<div class="modal-body">' +
      'To start your application please complete your <a style="color: #2ba1c6;" href="/student-dashboard/personal-information/">Personal information</a> section on your dashboard.' +
      '</div>' +
      '<div class="modal-footer" style="margin: 20px 0 0 0; padding: 0; border: 0;">' +
      '<button type="button" class="btn btn-primary" data-dismiss="modal" style="margin: 0 auto;padding: 7px 21px;">Close</button>' +
      '</div> ' +
      '</div>' +
      '</div>' +
      '</div>';
  $('body').append(modal);
  $('#apply-modal').modal().on('hidden.bs.modal', function (e) {
    $(this).remove();
  });
}